import styled from 'styled-components';
import { GRAY_50, GRAY_200, GRAY_500, GRAY_900, SUCCESS_700, ERROR_600 } from 'Config/colors';

// Intentionally self-contained: extending legacy components (e.g. SDMHeading)
// inherited their quirks like `margin-top: -10px !important`.
export const SectionCard = styled.div`
  margin-top: 20px;
  border: 1px solid ${GRAY_200};
  border-radius: 8px;
  padding: 16px;
`;

export const SectionHeading = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${GRAY_900};
  margin-top: 0px;
  margin-bottom: 4px;
`;

export const FieldGroup = styled.div`
  margin-top: 16px;
`;

export const ErrorText = styled.p`
  color: ${ERROR_600};
  margin-top: 3px;
  margin-bottom: 0px;
  font-size: 14px;
`;
// AIR ID check feedback: StatusText (grey, "checking"), SuccessText (green, "valid").
export const StatusText = styled.p`
  color: ${GRAY_500};
  margin-top: 3px;
  margin-bottom: 0px;
  font-size: 13px;
`;
export const SuccessText = styled(StatusText)`
  color: ${SUCCESS_700};
`;

// Grey fill so these read as nested items inside the white Robots SectionCard.
export const RobotCard = styled.div`
  margin-top: 12px;
  border: 1px solid ${GRAY_200};
  border-radius: 8px;
  padding: 12px;
  background-color: ${GRAY_50};
`;
export const RobotCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;
export const RobotTitle = styled.strong`
  font-family: 'Inter';
  font-weight: 600;
  font-size: 14px;
  color: ${GRAY_900};
`;
export const RemoveButton = styled.span`
  color: ${ERROR_600};
  font-size: 14px;
  margin-right: 12px;
  cursor: pointer;
`;
export const Chevron = styled.span`
  color: ${GRAY_500};
`;
export const AddRobotRow = styled.div`
  margin-top: 16px;
  cursor: pointer;
`;

export const CheckboxRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-left: 5px;

  label {
    margin-left: 8px;
    margin-bottom: 0px;
    cursor: pointer;
  }
`;
export const FormatRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 40px;
  margin-top: 8px;
  column-gap: 4px;
  background-color: ${GRAY_50};
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
`;
